import { useGetIdentity, useTranslate } from "ra-core";
import { useEffect } from "react";

import {
  launchSplash,
  resolveGreetingName,
  type SplashController,
} from "./launchSplash";
import { useSplashHold } from "./useSplash";
import "@/styles/splash.css";

/**
 * Admin `loading` page (the auth check, permission checks): renders nothing,
 * like ra-core's default, and holds the splash while mounted.
 */
export const SplashHold = () => {
  useSplashHold(true);
  return null;
};

const IdentityGate = ({ splash }: { splash: SplashController }) => {
  const translate = useTranslate();
  const { identity, isPending } = useGetIdentity();
  const name = isPending ? null : resolveGreetingName(identity);
  const greeting = name ? translate("crm.splash.greeting", { name }) : null;

  // Set before the hold is released, in the same effect pass.
  useEffect(() => {
    if (!isPending) splash.setGreeting(greeting);
  }, [isPending, greeting, splash]);
  useSplashHold(isPending, splash);
  return null;
};

/**
 * Rendered by the signed-in layouts: holds the splash until the identity is
 * loaded and hands it the "Hi, {name}" greeting.
 */
export const SplashIdentityGate = ({
  splash = launchSplash,
}: {
  splash?: SplashController | null;
}) => (splash?.isWaiting() ? <IdentityGate splash={splash} /> : null);
